export default __webpack_public_path__ + "static/media/twick2.420d432e.jpg";